import gql from 'graphql-tag';

// The note's registration as an offering in Alto (backend: investment/modules/alto-offering). Kept apart
// from apollo_queries / apollo_mutations: creating a note does NOT create its offering — registering is
// an explicit operator action, so a failure in Alto is never hidden behind a green "Note created".

// Both truths: `registered` is OUR flag (a cache), `existsInAlto` is what Alto holds right now, and
// `missingDocuments` is what Alto still waits for (while non-empty the investor is told they have no
// access to the deal).
export const ALTO_OFFERING_STATUS = gql`
  query adminAltoOfferingStatus($investmentId: String!) {
    adminAltoOfferingStatus(investmentId: $investmentId) {
      investmentId
      noteListing
      registered
      existsInAlto
      missingDocuments
      checkedAt
    }
  }
`;

// Creates the offering under the note's `noteListing` if Alto lacks it, uploads the documents it still
// misses, verifies, and only then marks the note. Re-running it answers ALREADY_REGISTERED.
export const REGISTER_ALTO_OFFERING = gql`
  mutation adminRegisterAltoOffering($investmentId: String!) {
    adminRegisterAltoOffering(data: { investmentId: $investmentId }) {
      investmentId
      noteListing
      outcome
      detail
    }
  }
`;
